import script from "./QuizDrawerPlayPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizDrawerPlayPanel.vue?vue&type=script&setup=true&lang=ts"

import "./QuizDrawerPlayPanel.vue?vue&type=style&index=0&id=5b664c19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b664c19"]])

export default __exports__